function ErrorComponent() {
  return <div>Unable to load beneficial owners list</div>;
}

export default ErrorComponent;
